
import { z } from "zod";

export const AppNameValues = ["HONO_SERVER", "NEXTJS", "NEXTJS_PORTAL", "RNR_SERVER", "SUNRUN_SQS"] as const;
export const AppNameSchema = /* @__PURE__ */ z.enum(AppNameValues);
export const AppName: (typeof AppNameSchema)["enum"] = { "HONO_SERVER": "HONO_SERVER", "NEXTJS": "NEXTJS", "NEXTJS_PORTAL": "NEXTJS_PORTAL", "RNR_SERVER": "RNR_SERVER", "SUNRUN_SQS": "SUNRUN_SQS" };
export type AppName = (typeof AppNameValues)[number];
export const AppNameDisplayNames = { "HONO_SERVER": "Hono server",
"NEXTJS": "NextJS",
"NEXTJS_PORTAL": "NextJS Portal",
"RNR_SERVER": "Remove and Reinstall server",
"SUNRUN_SQS": "Sunrun SQS", } satisfies Record<AppName, string>;
